import { IconButton } from "@fluentui/react";
import { Tag } from "@fluentui/react-components";
import { VariantDetail, VariantDetailFeatureFlags } from "../../../../Types";
import { DismissCircleFilled } from "@fluentui/react-icons";
import { notSetCell } from "../../../../Shared/TableRenderers";
import { styles, theme } from "../variantDetailsFormStyles";

export function featureFlagRenderer(
  featureFlags: VariantDetailFeatureFlags,
  onRemoveFlag: (flag: string) => void,
) {
  if (!featureFlags || Object.keys(featureFlags).length === 0) {
    return notSetCell("Feature flags not set");
  }
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
      {Object.entries(featureFlags).map(([key, value]) => {
        const normalizedValue = (
          typeof value === "boolean" ? (value ? "true" : "false") : value
        ).toString();
        return (
          <Tag
            shape="circular"
            key={key}
            dismissible
            dismissIcon={
              <DismissCircleFilled
                title="Remove feature flag"
                data-testid="remove-flag"
                color={theme.palette.neutralPrimaryAlt}
                onClick={() => onRemoveFlag(key)}
              />
            }
            className={styles.variantDetailsFlagPill}
          >
            <div className={styles.variantDetailsFlagTagContent}>
              <span title={key} className={styles.variantDetailsFlagKey}>
                {key}
              </span>
              <span>:</span>
              <span
                title={normalizedValue}
                className={styles.variantDetailsFlagValue}
              >
                {normalizedValue}
              </span>
            </div>
          </Tag>
        );
      })}
    </div>
  );
}

export function deleteButtonRenderer(
  item: VariantDetail,
  onDelete: (item: VariantDetail) => void,
) {
  return (
    <IconButton
      iconProps={{ iconName: "Delete" }}
      title="Delete"
      onClick={() => onDelete(item)}
    />
  );
}

export function editButtonRenderer(
  item: VariantDetail,
  onEdit: (item: VariantDetail) => void,
) {
  return (
    <IconButton
      iconProps={{ iconName: "Edit" }}
      title="Edit"
      onClick={() => onEdit(item)}
    />
  );
}
